<template>
    <ui-modal :title="title" :close="() => { close(); afterClose?afterClose():null; }" ref="modal">
        <template #icon>
            <div
                class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                <svg class="h-6 w-6 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                     stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
            </div>
        </template>
        <div>
            <ui-form-section>
                <ui-input label="Your Name" name="principleContractor"
                          v-model="form.name"
                          class="xl:col-span-12"></ui-input>
            </ui-form-section>
            <label class="block text-sm font-medium text-gray-700 mb-1 mt-1">Your Signature</label>
            <div class="flex items-center justify-center mt-2" ref="wrapper">
                <canvas
                    class="sign items-center justify-center inline-flex rounded-md border-gray-500 border p-0.5 mb-2"
                    width="2" height="2" ref="canvas"></canvas>
            </div>
            <div>
                <a class="text-gray-400 text-xs mb-2" href="#" @click="clearSignature">Clear Signature</a>
            </div>
        </div>
        <template #footer-primary>
            <span class="mt-0 flex w-full sm:mt-0 sm:w-auto">
                <ui-button-new primary class="w-full whitespace-nowrap"
                               :loading="form.busy || (signaturePad && signaturePad.isEmpty()) || (!form.name || (form.name.length===0))"
                               @click="form.submit()"
                               v-text="button"></ui-button-new>
            </span>
        </template>
    </ui-modal>
</template>

<script>
import Signature_pad from "signature_pad";
import UiInput from "../../../ui/UiInput.vue";
import UiButtonNew from "../../../ui/UiButtonNew.vue";
import UiFormSection from "../../../ui/UiFormSection.vue";

export default {
    components: {UiFormSection, UiButtonNew, UiInput},
    props: {
        handle: Function,
        handle2: Function,
        handle3: Function,
        close: Function,
        afterClose: Function,
        title: {
            type: String,
            default: 'Confirmation'
        },
        paragraphs: {
            type: Array,
            default: () => [
                'Are you sure you want to proceed?',
            ],
        },
        button: {
            type: String,
            default: 'Confirmed'
        },
    },
    data() {
        return {
            form: new Form({}, async (form) => {
                form.signature = this.signaturePad.toDataURL("image/jpeg")
                await this.handle(form)
                this.close()
            }),
            signaturePad: false,
        }
    },
    methods: {
        resize() {
            let canvas = this.$refs.canvas
            if (!canvas) {
                window.removeEventListener('resize', () => {
                    this.resize()
                });
            }
            if (canvas && canvas.width !== this.$refs.modal.$refs.headline.offsetWidth - 8) {
                canvas.width = this.$refs.modal.$refs.headline.offsetWidth - 8
                canvas.height = canvas.width / 2;
                let ctx = canvas.getContext("2d");
                ctx.fillStyle = "rgb(255,255,255)";
                ctx.fillRect(0, 0, canvas.width, canvas.height);
            }
        },
        clearSignature() {
            this.signaturePad.clear()
            let canvas = this.$refs.canvas
            if (canvas) {
                canvas.width = this.$refs.modal.$refs.headline.offsetWidth - 8
                canvas.height = canvas.width / 2;
                let ctx = canvas.getContext("2d");
                ctx.fillStyle = "rgb(255,255,255)";
                ctx.fillRect(0, 0, canvas.width, canvas.height);
            }
        },
    },
    mounted() {
        this.signaturePad = new Signature_pad(this.$refs.canvas, {})
        this.resize()
        window.addEventListener('resize', () => {
            this.resize()
        })
    }
}
</script>
